/** The Crown DSL playground page. */
import type { Instruction } from '@crown/framework/ir';
import { PlaygroundModel } from './dsl-playground-model';
import template from './dsl-playground.tsrx';

const DslPlayground: (props: { model: PlaygroundModel }) => Instruction =
  template;

export function DslPlaygroundPage(): Instruction {
  return DslPlayground({ model: new PlaygroundModel() });
}
